import { Link, LinkProps } from '@online-webinar/router';
import { ReactNode } from 'react';

interface Props extends Pick<LinkProps, 'to' | 'params' | 'state'> {
    classNames?: string;
    data: string | number;
    icon: ReactNode;
    subject: string;
}

export const WebinarDataItem = ({ classNames, data, icon, subject, to, params, state }: Props) => (
    <Link to={to} params={params} state={state} className={`webinar-item-data-item ${classNames}`}>
        <div>
            {icon}
            {data}
        </div>
        <span>{subject}</span>
    </Link>
);
